import __request__ from "routing/request";
export function createProcedure(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/event_procedures", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listProcedures(sort = "title", page = 1, per_page = 15, query, filters, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/event_procedures", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStepUsages(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/event_procedures/procedures_with_step/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listSteps(sort = "title", page = 1, per_page = 15, query, filters, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/event_procedures/steps", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createStep(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/event_procedures/steps", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteStep(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/event_procedures/steps/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editStep(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/event_procedures/steps/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStep(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/event_procedures/steps/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getViewParameters(id, type, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/event_procedures/view_parameters/${id}/${type}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getProcedure(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/event_procedures/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editProcedure(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/event_procedures/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteProcedure(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/event_procedures/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getProcedureForEvent(id, eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/event_procedures/${id}/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
